import(/* webpackMode: "eager", webpackExports: ["default"] */ "/kingsyard-ssr/src/components/TermsPrivacyPage/termsPrivacyPage.js");
